import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context9; _forEachInstanceProperty(_context9 = ownKeys(Object(source), true)).call(_context9, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context10; _forEachInstanceProperty(_context10 = ownKeys(Object(source))).call(_context10, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ENTITIES, ERROR, ITEMS, LISTS, STATUS, STATUS_ERROR, ETAG } from './constants';
import { createEtag } from './etags';
import { isArray, get } from 'lodash';

function setEntityError(state, group, id, error) {
  var _objectSpread2;

  // Normalize error array
  if (!isArray(error)) {
    error = [error];
  }

  var etag = createEtag();

  var newState = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, group, _objectSpread(_objectSpread({}, state[group]), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, state[group][id]), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, STATUS, STATUS_ERROR), _defineProperty(_objectSpread2, ERROR, error), _defineProperty(_objectSpread2, ETAG, etag), _objectSpread2))))));

  return newState;
}

export function setEntityListError(state, id, error) {
  return setEntityError(state, LISTS, id, error);
}
export function setEntityItemError(state, id, error) {
  return setEntityError(state, ITEMS, id, error);
}

function getEntityError(state, type, id, group) {
  var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8;

  var status = get(state, _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "".concat(ENTITIES, ".")).call(_context4, type, ".")).call(_context3, group, ".")).call(_context2, id, ".")).call(_context, STATUS));

  if (status !== STATUS_ERROR) {
    return false;
  }

  return get(state, _concatInstanceProperty(_context5 = _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = _concatInstanceProperty(_context8 = "".concat(ENTITIES, ".")).call(_context8, type, ".")).call(_context7, group, ".")).call(_context6, id, ".")).call(_context5, ERROR), true);
}

export function getEntityListError(state, type, id) {
  return getEntityError(state, type, id, LISTS);
}
export function getEntityItemError(state, type, id) {
  return getEntityError(state, type, id, ITEMS);
}